import React, {PureComponent} from 'react';
import {string, oneOf, object, any} from 'prop-types';
import Icon from '../../../components/Icon';
import styles from './Option.css';

export const optionValue = any;

const optionShape = {
  label: string,
  children: string,
  icon: object,
  value: optionValue.isRequired,
  theme: oneOf(['default', 'v2']),
};

class Option extends PureComponent {
    static propTypes = optionShape;

    static defaultProps = {
      theme: 'default',
    }

    render() {
      const {label, value, theme, children, icon} = this.props;

      return theme === 'v2' ?
        <div className={styles.optionV2}>{icon && <Icon className={styles.icon} icon={icon} size="14" />}{children || label}</div> :
        <option className={styles.option} label={label} value={value} />;
    }
}

export default Option;
